import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faBars, faTimes} from "@fortawesome/free-solid-svg-icons";
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';


const menuItems = [
    { id: 1, titleKey: "menu.home", link: "#header" },
    { id: 2, titleKey: "menu.services", link: "#services" },
    { id: 3, titleKey: "menu.rooms", link: "#rooms" },
    { id: 4, titleKey: "menu.reviews", link: "#customers" },
];
Modal.setAppElement('#root');

function Menu() {
    const { t } = useTranslation();
    const [modalIsOpen, setIsOpen] = React.useState(false);
    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    return (
        <div>
        <div className="site-nav">
            <span id="nav-btn" onClick={openModal}>MENU <FontAwesomeIcon icon={faBars} /></span>
        </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="sidenav"
            >
              <span className="cancel-btn" id="cancel-btn" onClick={closeModal}>
                <FontAwesomeIcon icon={faTimes} />
              </span>

                    <ul className="navbar">
                        {menuItems.map((item) => (
                            <li key={item.id}>
                                <a href={item.link}>{t(item.titleKey)}</a>
                            </li>
                        ))}
                    </ul>
                    
                    <div className="sidenav-language-switcher">
                        <LanguageSwitcher />
                    </div>
            </Modal>
        </div>
    );
}

export default Menu;
